import TopBanner from "./topBanner";
import FeaturesOverview from "./featuresOverview";

import "./index.scss";

const CorporateWellness = () => (
  <>
    <TopBanner />
    <FeaturesOverview />
  </>
);

export default CorporateWellness;
